<template>
  <div class="list" style="width:100%">
    <Header :title="$t('m.TerminaltimeDetail')"></Header>
    <div class="contentitem grebgc">
      <div class="itemlist spebgc">
        <p
          :key="index"
          v-for="(item,index) in terminaltimeinfo"
        >
          <span @click="tomeetingdetail(item.id)">{{item.id}}</span>
          <span class="right">{{item.time}}</span>
          <!--          <span class="right img">-->
          <!--              <Button type="error" @click="deleteTemplate(item)">-->
          <!--                  <Icon type="ios-trash"/>-->
          <!--              </Button>-->
          <!--          </span>-->
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../header/header'
  import {findTerminalTimeById} from '../../assets/js/url'

  export default {
    data() {
      return {
        terminaltimeinfo: []
      };
    },
    components: {
      Header
    },
    activated() {
      this.loadTerminalData()
    },
    computed: {
      imgpath() {
        return this.$store.state.imagestyle[this.$store.state.cssstyle]
      }
    },
    methods: {
      activated () {
        this.loadTerminalData()
      },
      formatDate(timestrap) {
        let date = new Date(timestrap);
        let YY = date.getFullYear() + '-';
        let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + MM + DD + " " + hh + mm + ss;
      },
      loadTerminalData: function () {
        this.$http.post(findTerminalTimeById, {
          terminalId: this.$route.query.terminalId
        }).then(
          res => {
            // id: '11924ec633704fc5a00bbee89d563e38',
            // time: '2019-03-28 18:24:38 ~ 19:24:38'
            if (res.data.status === 2000) {
              let data = res.data.data
              for (let index in data) {
                let item = {
                  id: data[index].id,
                  time: this.formatDate(data[index].begin_time) + '~' + this.formatDate(data[index].end_time)
                }
                this.terminaltimeinfo.push(item)
              }
            }
          }
        )
      },
      tomeetingdetail (item) {
        this.$router.push({
          name: 'meetingdetail',
          query: {
            meetinguuid: item
          }
        })
      }
    }
  };
</script>
<style scoped>
  .itemlist p {
    padding: 0 0.15rem;
    height: 0.41rem;
    line-height: 0.41rem;
    font-size: 0.14rem;
  }

  .itemlist p:nth-child(2n) {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .right {
    float: right;
    height: 0.41rem;
    line-height: 0.41rem;
    font-size: 0.14rem;
    text-decoration: none !important;
  }

  .right img {
    width: 0.18rem;
    height: 0.18rem;
    vertical-align: middle;
    margin-left: 0.2rem;
  }

  .width {
    display: inline-block;
    width: 49%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-decoration: underline;
  }

  .time,
  .relativetime {
    display: inline-block;
  }

  .time {
    width: 60%;
    text-align: center;
  }

  .relativetime {
    width: 40%;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/terminaltimeinfo.vue